import httpClient from './httpClient';

export const fetchTutorProfile = async (tutorId) => {
  const { data } = await httpClient.get(`/tutors/${tutorId}/profile`);
  return data;
};

export const updateTutorProfile = async (tutorId, payload) => {
  const { data } = await httpClient.put(`/tutors/${tutorId}/profile`, payload);
  return data;
};

export const addTutorReview = async (tutorId, payload) => {
  const { data } = await httpClient.post(`/tutors/${tutorId}/reviews`, payload);
  return data;
};

export const updateTutorReview = async (reviewId, payload) => {
  const { data } = await httpClient.put(`/tutors/reviews/${reviewId}`, payload);
  return data;
};

export const deleteTutorReview = async (reviewId) => {
  await httpClient.delete(`/tutors/reviews/${reviewId}`);
};

export const updateDailyMood = async (tutorId, mood) => {
  const { data } = await httpClient.put(`/tutors/${tutorId}/daily-mood`, { mood });
  return data;
};
